<template>
    <LayoutDefault>
        <div
              class="container"
              id="model_index"
        >
            <section class="categories">
                <h3 class="title">
                  {{$t('header.models')}}
                </h3>
                <template v-if="!loadingModels && !errorModels">
                    <template v-if="models.length !== 0">
                        <div class="models">
                            <ModelBox
                                    v-for="model in models"
                                    :model="model"
                                    :key="model.id"
                            />
                        </div>
                        <div v-if="!loadingMoreModels && modelsCurrentPage">
                            <button
                                    type="button"
                                    @click.prevent="loadMoreModels"
                            >
                                {{$t('load_more')}}
                            </button>
                        </div>
                        <Spinner v-if="loadingMoreModels"/>
                    </template>
                    <template v-else>
                        <p>
                            {{$t('noRecords')}}
                        </p>
                    </template>
                </template>
                <template v-else>
                    <Spinner v-if="loadingModels"/>
                    <template v-if="errorModels">
                        <p>
                            {{$t('error')}}
                        </p>
                        <button
                                type="button"
                                @click="loadModels"
                        >
                            {{$t('retry')}}
                        </button>
                    </template>
                </template>
            </section>
        </div>
    </LayoutDefault>
</template>

<script>
    import ModelBox from '../components/ModelBox';
    import Spinner from '../components/Spinner';

    import EventBus from '../eventbus';

    import resources from '../resources';
    import LayoutDefault from "../layouts/LayoutDefault";

    const resultsPerPage = 999;

    export default {
        components: {
            LayoutDefault,
            ModelBox,
            Spinner,
        },
        methods: {
            loadModels(){
                this.loadingModels = true;
                this.loadingMoreMorels = false;
                this.errorModels = false;
                this.models = null;
                this.modelsCurrentPage = null;

                resources.models.index({per_page: resultsPerPage, priority: 1, page: 1})
                    .then((response) => {
                        this.errorModels = false;
                        this.loadingModels = false;
                        this.models = response.data.data;
                    }).catch(() => {
                        this.loadingModels = false;
                        this.errorModels = true;
                    });
            },
            loadMoreModels(){
                this.loadingMoreModels = true;

                resources.models.index({per_page: resultsPerPage, priority: 1, page: this.modelsCurrentPage + 1})
                    .then((response) => {
                        this.loadingMoreModels = false;
                        this.models = this.models.concat(response.data.data);

                        if(response.data.data.length === resultsPerPage){
                            this.modelsCurrentPage++;
                        }else{
                            this.modelsCurrentPage = null;
                        }
                    }).catch(() => {
                        this.loadingMoreModels = false;
                    });
            },
        },
        data(){
            return {
                loadingMoreModels: false,
                loadingModels: true,
                errorModels: false,
                models: null
            }
        },
        mounted(){
            this.loadModels();

            EventBus.$on('languageChanged', () => {
                this.loadModels();
            });
        },
    }
</script>

<style scoped lang="scss">
    @import '../styles/variables';

  #model_index{
    background-color: $pallete_clear_color;
    min-height: 500px;
    padding: 9px;

    .models{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -5px;

      .model{
        flex-grow: 0;
        margin-bottom: 60px;
        flex-basis: 16.6666%;

        @media(max-width: 900px){
          flex-basis: 50%;
        }

        @media(max-width: 600px){
          flex-basis: 100%;
        }
      }
    }
  }
</style>
